import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useHistory, useParams} from 'react-router-dom'
import dayjs from 'dayjs'
import {RootState} from '../../../../../setup'
import {QueryData} from '../../../../reusable-components/tables/DynamicTableTypes'
import {toast} from 'react-toastify'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import {
  RECORDS_COLUMNS_DATA_MAPPING,
  RECORDS_LISTING_COLUMNS,
  RECORDS_SORTING_COLUMNS,
} from '../../../Notes/Nurses_Notes/GENERAL_TABLE_CONSTANTS'

const selectTimeZone = (state: RootState) => state.timeZone.timeZone

const DeletedNursesNotesList = () => {
  const [filteredData, setFilteredData] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [isFetchingData, setIsFetchingData] = useState(true)
  const timeZone = useSelector(selectTimeZone)
  const history = useHistory()
  const params: {id: string} = useParams()
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })

  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string) => {
      setIsFetchingData(true)
      try {
        const response = await axios.get(`/nursesNotes/getByClient/${params.id}?isDeleted=true`, {
          params: {
            page: page,
            pageSize: pageSize,
            sortBy: sortBy,
            sortDir: sortDir,
            searchTerm: queryData.searchTerm,
          },
        })
        const {data, currentPage, totalCounts} = response?.data
        const mappedData = data.map((item) => {
          const adjustedStartDate = new Date(item.startDate)
          adjustedStartDate.setDate(adjustedStartDate.getDate())
          const adjustedEndDate = new Date(item.endDate)
          adjustedEndDate.setDate(adjustedEndDate.getDate())
          const formattedStartDate = `${(adjustedStartDate.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${adjustedStartDate
            .getDate()
            .toString()
            .padStart(2, '0')}-${adjustedStartDate.getFullYear().toString().slice(-2)}`
          const formattedEndDate = `${(adjustedEndDate.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${adjustedEndDate
            .getDate()
            .toString()
            .padStart(2, '0')}-${adjustedEndDate.getFullYear().toString().slice(-2)}`
          const dateRange = `${formattedStartDate} to ${formattedEndDate}`
          return {
            _id: item._id,
            dateRange,
            noteType: item.noteType,
            visitType: item.visitType,
            clientName: item.clientFullName || 'N/A',
            date: item.date,
            clientFullName: item.clientFullName,
          }
        })
        setFilteredData(mappedData)
        setQueryData((prevState) => {
          return {
            ...prevState,
            currentPage,
            totalCounts,
          }
        })
      } catch (err) {
        console.error('Error fetching data:', err)
      } finally {
        setIsFetchingData(false)
      }
    }
    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir)
  }, [
    queryData.pageNumber,
    queryData.pageSize,
    queryData.sortBy,
    queryData.sortDir,
    queryData.searchTerm,
  ])

  const onUpdate = ({_id}: {_id: string}) => {
    history.push(`/deleted-notes/nurses-notes/noteEntries/entry/${_id}`)
  }

  const onView = (row: any) => {
    history.push(`/deleted-notes/nurses-notes/noteEntries/entry/${row['_id']}`)
  }

  return (
    <div className='card'>
      <div className='card-body'>
        <div>
          <TableTitle title='Deleted Nurses Notes' />
          <TableWrapper
            searchField={
              <TableSearchBar
                label='Search'
                variant='outlined'
                size='small'
                value={searchTerm}
                setQueryData={setQueryData}
                setSearchTerm={setSearchTerm}
                margin='normal'
                inputAdornmentPosition='start'
              />
            }
            dynamicTable={
              <DynamicTable
                htmlColumns={[]}
                columns={RECORDS_LISTING_COLUMNS}
                data={filteredData}
                canDownload={false}
                canUpdate={true}
                canDelete={false}
                columnDataMapping={RECORDS_COLUMNS_DATA_MAPPING}
                sortingColumns={RECORDS_SORTING_COLUMNS}
                clickableRow={false}
                onUpdate={onUpdate}
                onView={onView}
                tableLoader={isFetchingData}
                setQueryData={setQueryData}
                queryData={queryData}
              />
            }
          />
        </div>
      </div>
    </div>
  )
}
export default DeletedNursesNotesList